import { CaaksError } from 'src/app/shared/error/errors';
export interface ErrorState {
  error: CaaksError | null;
}

export const initialErrorState: ErrorState = {
  error: null,
};
